/**
 * Created by alvinoktavianus on 6/29/17.
 */

import { Component } from 'react'
import moment from 'moment'
import {currencyFormatter} from 'utils/formatter'

import styles from './FeatureTrialPage.css'

class FeatureTrialPage extends Component {
  render () {
    const {featureName, featurePricePerMonths, description, trialEndAt, featureIcon, featureVideo, startTrial, discountPriceLowerBound} = this.props
    return (
      <div className={styles['splash-page']}>
        <div className={styles['splash-content']}>
          <p className='text-center'>
            <img src={featureIcon} className={`img-circle ${styles['feature-logo']}`} />
          </p>
          <h3 className={`text-center ${styles['splash-title']}`}>{featureName}</h3>
          <p className={styles['feature-description']}>{description}</p>
          <p className={`text-center ${styles['splash-video']}`}>
            <iframe width='248' height='167' src={featureVideo} frameBorder={0} allowFullScreen id='video' />
          </p>
          <p className={styles['pricing-message']}>Pricing</p>
          <table className={styles['pricing-table']}>
            <tr className={styles['pricing-row']}>
              <td align='left' className={styles['pricing-colomn']}>{featureName}</td>
              {(featurePricePerMonths < discountPriceLowerBound) && <td className={`text-right ${styles['pricing-colomn']} ${styles['pricing-colomn-discount']}`}>{currencyFormatter(discountPriceLowerBound)}</td>}
              <td className={`text-right ${styles['pricing-colomn']}`}>{currencyFormatter(featurePricePerMonths)}/mo</td>
            </tr>
          </table>
          <button className={`btn btn-block btn-primary ${styles['btn-use-feature']}`} onClick={startTrial}><strong>Start Free Trial</strong></button>
          <p className={styles['feature-due-date']}>Your free trial due on {moment(trialEndAt).format('DD MMM YYYY')}</p>
        </div>
      </div>
    )
  }
}

export default FeatureTrialPage



// WEBPACK FOOTER //
// ./app/components/FeatureTrialPage/FeatureTrialPage.js